var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 37 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.813 17c0-5.799 4.7-10.5 10.5-10.5s10.5 4.701 10.5 10.5c0 2.829-1.12 5.396-2.938 7.284a1.5 1.5 0 0 0-.279.279 10.47 10.47 0 0 1-7.283 2.937c-5.8 0-10.5-4.701-10.5-10.5m18.926 10.548a13.44 13.44 0 0 1-8.426 2.952c-7.456 0-13.5-6.044-13.5-13.5s6.044-13.5 13.5-13.5c7.455 0 13.5 6.044 13.5 13.5 0 3.188-1.105 6.117-2.953 8.427l5.513 5.512a1.5 1.5 0 0 1-2.121 2.122z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSearch;